

document.addEventListener('DOMContentLoaded', () => {

  const loop = setInterval(() => {
    const elements = document.querySelectorAll('[data-fdt-product-id]');

    if (elements.length) {

      elements.forEach(element => {
        const product_id = element.getAttribute('data-fdt-product-id');

        if (product_id) {
          const Id = product_id.split('/').pop();
          let a = element.querySelector('.search-filters__product-price-content')

          if (a) {
            a.setAttribute('bss-b2b-product-id', Id )
            a.setAttribute('bss-b2b-product-price','')
          }

        }
      });
      setTimeout(async () => {
       const res = await BSS_B2B.storage.productStorage.load();
        if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {

            await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                ...res,
            });

        }
      }, 300);
     
      // Đã tìm thấy → dừng loop
      clearInterval(loop);
    }
  }, 100);

  // Safety: dừng sau 15s nếu không tìm thấy
  setTimeout(() => {
    clearInterval(loop);
  }, 7000);

});